import { FC, useState } from 'react';

import styles from './CartItem.module.scss';
import { useActions } from '../../../../../lib/hooks/useActions';
import StatusNew from '../../../../StatusNew/StatusNew';
import Minus from '../../../../Icons/Minus';
import Plus from '../../../../Icons/Plus';
import { generateImageUrl } from '../../../../../helpers/generateImageUrl';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { CrossIcon } from '../../../../Icons/Cross';

export interface ICartItem {
  product_id: string;
  name: string;
  article_number: string;
  cmmf: string;
  type: string;
  image?: string | null;
  count: number;
  status: string;
  comment?: string;
  available: number;
}

const CartItem: FC<ICartItem> = ({
  product_id,
  name,
  count,
  status,
  comment,
  article_number,
  type,
  image,
  available,
}) => {
  const { removeItem, updateCount, updateComment } = useActions();
  const [currentCount, setCurrentCount] = useState<number | ''>(count);
  const [currentComment, setCurrentComment] = useState<string>(comment || '');
  const [showButtons, setShowButtons] = useState<boolean>(false);

  const [edit, setEdit] = useState(false);

  return (
    <div className={styles.CartItem}>
      <div className={styles.content}>
        <img
          className={styles.image}
          src={image ? generateImageUrl(image) : '/images/placeholderImage.png'}
        />
        <div className={styles.info}>
          <div className={styles.holder}>
            <div className={styles.holder_wrap}>
              <div className={styles.mainInfo}>
                <div className={styles.status_holder}>
                  <StatusNew status={status} count={available} />
                </div>
                <Link
                  to={'/product/' + product_id}
                  state={{
                    type: type === 'detail' || type === 'extra' ? 'part' : type,
                  }}
                >
                  {name}
                </Link>
                <span>{article_number}</span>

                <div className={styles.count}>
                  <button
                    onClick={() => {
                      const newCount = +currentCount - 1;
                      setCurrentCount(newCount);
                      updateCount({ product_id: product_id, count: newCount });
                    }}
                    disabled={+currentCount <= 1}
                  >
                    <Minus />
                  </button>
                  <input
                    value={+currentCount >= 0 ? currentCount : ''}
                    onInput={(e) =>
                      setCurrentCount(
                        +(e.target as HTMLTextAreaElement).value < 999 &&
                          +(e.target as HTMLTextAreaElement).value !== 0
                          ? +(e.target as HTMLTextAreaElement).value.replace(
                              /[^0-9]/g,
                              '',
                            )
                          : +(e.target as HTMLTextAreaElement).value === 0
                            ? ''
                            : +(e.target as HTMLTextAreaElement).value.slice(
                                0,
                                3,
                              ),
                      )
                    }
                    onBlur={() => {
                      if (currentCount === '') {
                        setCurrentCount(1);
                        updateCount({ product_id: product_id, count: 1 });
                      } else {
                        updateCount({
                          product_id: product_id,
                          count: currentCount,
                        });
                      }
                    }}
                  />
                  <button
                    onClick={() => {
                      const newCount = +currentCount + 1;
                      setCurrentCount(newCount);
                      updateCount({ product_id: product_id, count: newCount });
                    }}
                    disabled={+currentCount >= 999}
                  >
                    <Plus />
                  </button>
                </div>
              </div>
            </div>
            <div className={styles.countWrap}>
              <div className={styles.count}>
                <button
                  onClick={() => {
                    const newCount = +currentCount - 1;
                    setCurrentCount(newCount);
                    updateCount({ product_id: product_id, count: newCount });
                  }}
                  disabled={+currentCount <= 1}
                >
                  <Minus />
                </button>
                <input
                  value={+currentCount >= 0 ? currentCount : ''}
                  onInput={(e) =>
                    setCurrentCount(
                      +(e.target as HTMLTextAreaElement).value < 999 &&
                        +(e.target as HTMLTextAreaElement).value !== 0
                        ? +(e.target as HTMLTextAreaElement).value.replace(
                            /[^0-9]/g,
                            '',
                          )
                        : +(e.target as HTMLTextAreaElement).value === 0
                          ? ''
                          : +(e.target as HTMLTextAreaElement).value
                                .replace(/[^0-9]/g, '')
                                .slice(0, 3) === 0
                            ? ''
                            : +(e.target as HTMLTextAreaElement).value
                                .replace(/[^0-9]/g, '')
                                .slice(0, 3),
                    )
                  }
                  onBlur={() => {
                    if (currentCount === '') {
                      setCurrentCount(1);
                      updateCount({ product_id: product_id, count: 1 });
                    } else {
                      updateCount({
                        product_id: product_id,
                        count: currentCount,
                      });
                    }
                  }}
                />
                <button
                  onClick={() => {
                    const newCount = +currentCount + 1;
                    setCurrentCount(newCount);
                    updateCount({ product_id: product_id, count: newCount });
                  }}
                  disabled={+currentCount >= 999}
                >
                  <Plus />
                </button>
              </div>
              <div className={styles.deleteBtn}>
                <button onClick={() => removeItem({ product_id: product_id })}>
                  <img src={'/icons/cart.svg'} alt="delete" />
                </button>
              </div>
            </div>
          </div>
          <div
            className={styles.comment}
            onPointerEnter={() => !edit && setShowButtons(true)}
          >
            {edit ? (
              <div className={styles.commentInputWrap}>
                <textarea
                  className={styles.commentInput}
                  placeholder="Комментарий"
                  value={currentComment}
                  onChange={(e) => {
                    setCurrentComment(e.target.value.slice(0, 250));
                    e.target.style.cssText = 'height:5px; padding:0';
                    e.target.style.cssText =
                      'height:' + (e ? e.target.scrollHeight + 52 : 72) + 'px';
                  }}
                  onFocus={(e) => {
                    if (currentComment.length) {
                      e.target.style.cssText = 'height:5px; padding:0';
                      e.target.style.cssText =
                        'height:' +
                        (e ? e.target.scrollHeight + 52 : 72) +
                        'px';
                    }
                  }}
                  autoFocus
                />
                <button
                  className={styles.saveBtn}
                  onClick={() => {
                    updateComment({
                      product_id: product_id,
                      comment: currentComment,
                    });
                    setEdit(false);
                  }}
                  disabled={!currentComment.trim()}
                >
                  Отправить
                </button>
                <button
                  className={styles.cancelBtn}
                  onClick={() => {
                    setCurrentComment(comment || '');
                    setEdit(false);
                  }}
                >
                  <img src="/icons/plus.svg" alt="plus" />
                </button>
              </div>
            ) : currentComment ? (
              <div
                className={`${styles.commentHolder} ${styles.commentHolderFilled}`}
              >
                <span>
                  <img src={'/icons/comment.svg'} alt="comment" />
                  {currentComment}
                </span>
                {showButtons && (
                  <div className={styles.commentActions}>
                    <button
                      className={styles.editBtn}
                      onClick={() => setEdit(true)}
                    >
                      <img src="/icons/edit.svg" alt="edit" />
                    </button>
                    <button
                      onClick={() => {
                        setCurrentComment('');
                        updateComment({ product_id: product_id, comment: '' });
                      }}
                    >
                      <img src="/icons/cancel-grey.svg" alt="cancel" />
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className={styles.commentHolder}>
                <span
                  className={styles.commentHolderEditable}
                  onClick={() => setEdit(true)}
                >
                  <img src={'/icons/comment.svg'} alt="comment" />
                  Добавить комментарий
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className={clsx(styles.comment, styles.mob)}
        onPointerEnter={() => !edit && setShowButtons(true)}
      >
        {edit ? (
          <div className={styles.pupup_comment}>
            <div className={styles.popup_header}>
              <h4>Добавить комментарий</h4>
              <button
                onClick={() => {
                  setCurrentComment(comment || '');
                  setEdit(false);
                  document.body.style.overflow = 'auto';
                }}
              >
                <CrossIcon />
              </button>
            </div>

            <div className={styles.commentInputWrap}>
              <textarea
                className={styles.commentInput}
                placeholder="Комментарий"
                value={currentComment}
                onChange={(e) => {
                  setCurrentComment(e.target.value.slice(0, 250));
                  e.target.style.cssText = 'height:5px; padding:0';
                  e.target.style.cssText =
                    'height:' + (e ? e.target.scrollHeight + 52 : 72) + 'px';
                }}
                onFocus={(e) => {
                  if (currentComment.length) {
                    e.target.style.cssText = 'height:5px; padding:0';
                    e.target.style.cssText =
                      'height:' + (e ? e.target.scrollHeight + 52 : 72) + 'px';
                  }
                }}
                autoFocus
              />
              <button
                className={styles.saveBtn}
                onClick={() => {
                  updateComment({
                    product_id: product_id,
                    comment: currentComment,
                  });
                  setEdit(false);
                  document.body.style.overflow = 'auto';
                }}
                disabled={!currentComment.trim()}
              >
                Отправить
              </button>
              <button
                className={styles.cancelBtn}
                onClick={() => {
                  setCurrentComment(comment || '');
                  setEdit(false);
                  document.body.style.overflow = 'auto';
                }}
              >
                <img src="/icons/plus.svg" alt="plus" />
              </button>
            </div>
          </div>
        ) : currentComment ? (
          <div
            className={`${styles.commentHolder} ${styles.commentHolderFilled}`}
          >
            <span>
              <img src={'/icons/comment.svg'} alt="comment" />
              {currentComment}
            </span>
            {showButtons && (
              <div className={styles.commentActions}>
                <button
                  className={styles.editBtn}
                  onClick={() => {
                    setEdit(true);
                    document.body.style.overflow = 'hidden';
                  }}
                >
                  <img src="/icons/edit.svg" alt="edit" />
                </button>
                <button
                  onClick={() => {
                    setCurrentComment('');
                    updateComment({ product_id: product_id, comment: '' });
                  }}
                >
                  <img src="/icons/cancel-grey.svg" alt="cancel" />
                </button>
              </div>
            )}
          </div>
        ) : (
          <div className={styles.commentHolder}>
            <span
              className={styles.commentHolderEditable}
              onClick={() => {
                setEdit(true);
                document.body.style.overflow = 'hidden';
              }}
            >
              <img src={'/icons/comment.svg'} alt="comment" />
              Добавить комментарий
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CartItem;
